import React from 'react';
import {
  ClaySubscription,
  EntitlementName,
  ProductName,
  UserProfileRequest,
  UserSession,
} from '@app/types';
import Contact from '@models/Contact';

export type GetEntitlementValueFn = (entitlement: EntitlementName) => boolean | number | null;

export interface AuthContextSchema {
  user?: UserSession;
  subscriptions: ClaySubscription[];
  isReady: boolean;
  accountProcessingStatus?: string;
  pollForAccountStatus: () => void;
  updateLocalUserProfile: (userProfile: Partial<UserSession>) => void;
  updateUserProfile: (userProfile: UserProfileRequest) => Promise<boolean>;
  getEntitlementValue: GetEntitlementValueFn;
  setUserPrimaryProduct: (productName: ProductName) => void;
  // toggleDevUserEntitlement: (entitlement: UserEntitlement) => void;
  cleanupAndLogout: () => void;
  fetchUserData: () => void;
  contactLimit?: number;
  contactIsRestricted: (contact: Contact) => boolean;
  getIsFreePlan: () => boolean;
  getIsProPlan: () => boolean;
  getIsTeamsPlan: () => boolean;
}

// @ts-ignore - we pass undefined instead of a default ctx
export const AuthContext = React.createContext<AuthContextSchema>();
